import { ADS_WATCHED, ADS_ROLL_TYPE_BRID } from "@constants";
var adsBridJsClassObject = null;
export class AdsBridJs {
    constructor(AdsClass) {
        this.adsClass = AdsClass;
        this.bridAdRequestMade = false;
        adsBridJsClassObject = this;
        this.adsClass.cycleAndCompileAllTagVast();
        this.startBridPlayerAdsEventHandlers();
    }
    /**
     * Avvio dell'ad break per il player Brid
     * @param {Int} adRollType - Indica se il player è preroll, midroll o postroll
     */
    playAdsBridPlayer(adRollType) {
        $(".brid-play-control").addClass("!hidden");
        this.adsClass.tagVastTypeBrid = adRollType;
        if (this.adsClass.tagVastTypeBrid == ADS_ROLL_TYPE_BRID.MID_ROLL_BRID &&
            this.adsClass.isAdsPlayingStatus == 1) {
            this.adsClass.currentAdType = 1;
            // this.adsClass.videoPlayer.playAd(this.actualTagUrl);
            this.adsClass.videoPlayer.pushAds();
        }
    }
    /**
     * Set Up della parte ads per il player BRID
     */
    setupAdsBridPlayer() {
        console.log("Inizio setupAdsBridPlayer");
        // let currentTagVastURL = this.getVastForADSAndVideoType();
        // Riduco di 1 il tipo di ads perché sul Brid Player pre roll = 0, mid roll = 1 e post roll = 2
        // this.videoPlayer.setAd({
        //     "adType": "" + (this.actualTypeRollLoaded - 1) + "", //pre-roll
        //     "adTimeType": "s"
        // });
    }
    /**
     * Restart della gestione di ads per il player BRID
     */
    restartAdFromBridPlayer() {
        $(".brid-play-control").removeClass("!hidden");
        // if (this.isAdsPlayingStatus == true)
        // {
        //     $(this.fillerGif).removeClass('!hidden');
        // }
        // else
        // {
        //     $(this.fillerGif).addClass('!hidden');
        // }
        if (this.adsClass.completeAdsResumeAlreadyStarted === 0) {
            this.adsClass.completeAdsResumeAlreadyStarted = 1;
            //Levato il countdown della pubblicità
            if (this.adsClass.countdownTimer) {
                clearInterval(this.adsClass.intervalTimer);
            }
            if (this.adsClass.hasStartedAdsOnce == false) {
                this.adsClass.failedAdsSaveOnDb();
            }
            this.adsClass.adsInitializer();
        }
        this.adsClass.completeAdsResumeAlreadyStarted = 0;
    }
    /**
     * Inizializzazione degli event handlers per il player BRID
     */
    startBridPlayerAdsEventHandlers() {
        // TODO: mettere salvataggio good end su db
        this.adsClass.videoPlayer.on("adStart", () => {
            console.log("adStart");
            this.adsClass.hasStartedAdsOnce = true;
            // La richiesta è andata a buon fine
            this.bridAdRequestMade = false;
            $(this.adsClass.fillerGif).addClass("!hidden");
            this.adsClass.setAdEventOnDB(ADS_WATCHED);
        });
        this.adsClass.videoPlayer.on("AdsManagerLoadedEvent", () => {
            console.log("AdsManagerLoadedEvent");
        });
        this.adsClass.videoPlayer.on("requestAd", () => {
            console.log("requestAd");
            // Se il valore è true, vuol dire che è già stata fatta una adRequest
            // Vuol dire che non è andata a buon fine
            if (this.bridAdRequestMade == true) {
                this.adsClass.failedAdsSaveOnDb();
            }
            this.bridAdRequestMade = true;
        });
        this.adsClass.videoPlayer.on("adEnd", () => {
            console.log("adEnd");
            // if((this.bridAdRequestMade == true) && (this.hasStartedAdsOnce == false))
            // {
            //     this.failedAdsSaveOnDb();
            // }
            // Inizializzo campo per controllo adRequest di Brid
            this.bridAdRequestMade = false;
            this.adsClass.hasStartedAdsOnce == false;
            switch (this.adsClass.tagVastTypeBrid) {
                case ADS_ROLL_TYPE_BRID.PRE_ROLL_BRID:
                    this.adsClass.adsCustomizationPreRoll = 0;
                    break;
                case ADS_ROLL_TYPE_BRID.POST_ROLL_BRID:
                    this.adsClass.adsCustomizationPostRoll = 0;
                    // Nel Player.js legacy il passaggio al contenuto successivo veniva
                    // gestito fuori da Ads. Nel port React richiamiamo la stessa callback
                    // solo dopo la chiusura effettiva del post-roll Brid.
                    if (this.adsClass.videoEnded == true) {
                        this.adsClass.playerObject?.goToNextVideo?.();
                        return;
                    }
                    break;
            }
            this.restartAdFromBridPlayer();
        });
        this.adsClass.videoPlayer.on("bidWon", () => {
            console.log("bidWon");
        });
        this.adsClass.videoPlayer.on("vpaidStart", () => {
            console.log("vpaidStart");
        });
        // TODO: mettere salvataggio bad end su db in caso di errore
        this.adsClass.videoPlayer.on("adComplete", () => {
            console.log("adComplete");
        });
        this.adsClass.videoPlayer.on("adSkip", () => {
            console.log("adSkip");
        });
        this.adsClass.videoPlayer.on("adError", (error) => {
            console.log("");
            console.log("----- ERRORE ------");
            console.log(error);
            console.log(error.data.code);
            console.log(error.data.message);
            console.log("adError");
            console.log("-------------------");
            console.log("");
            this.adsClass.failedAdsSaveOnDb();
        });
    }
}
